/*
 * @Description:
 * @Author: henry
 * @Date: 2025-03-20 10:05:52
 * @LastEditors: henry
 * @LastEditTime: 2025-04-22 19:29:22
 */
import { ElMessage, ElLoading, ElMessageBox } from 'element-plus'

const hisObj = {}
export function toast(message, type = 'success', duration) {
  const now = Date.now()
  if (now - hisObj[message] < 1000 * 3) return
  hisObj[message] = now

  ElMessage({
    message,
    duration,
    type
  })
}

export function confirm(title, desc, success, cancel, close, confirmButtonText = '确认', cancelButtonText = '取消') {
  ElMessageBox.confirm(
    desc,
    title,
    {
      confirmButtonText,
      cancelButtonText,
      type: 'warning',
      distinguishCancelAndClose: true,
    }
  )
    .then(() => {
      success?.()
    })
    .catch((err) => {
      if (err === 'cancel') {
        cancel?.()
      } else {
        close?.()
      }
    })
}

let _loadingInstance
let stopTimer = null
export function loading(target, text = '') {
  if (!_loadingInstance) {
    _loadingInstance = ElLoading.service({
      lock: true,
      background: 'rgba(255,255,255,.3)',
      text: text || '',
      target
    })
  }
}

export function stopLoading() {
  clearTimeout(stopTimer)
  stopTimer = setTimeout(() => {
    _loadingInstance && _loadingInstance.close()
    _loadingInstance = null
  }, 10)
}

/**
 * @description: 存储localStorage
 * @param {*} key
 * @param {*} value
 * @return {*}
 */
export const storage = {
  set(key, value) {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  },

  get(key) {
    const value = localStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  },

  remove(key) {
    localStorage.removeItem(key);
  },

  clear() {
    localStorage.clear();
  }
};
